/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ({

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

/**
 * Give - Stripe Popup Checkout JS
 */

jQuery(document).ready(function ($) {

	var donate_button_val = $('.give-submit-button-wrap input[type="submit"]').val();

	$('form[id^=give-form]').on('submit', function (e) {

		// Form that has been submitted.
		var $form = $(this);
		var $form_submit = $(this).find('.give-submit-button-wrap input[type="submit"]');

		// Ensure the Plaid modal displays above.
		$form.append("<style>#plaid-link-iframe { z-index: 2147483541 !important; }</style>");
		// Disable submit.
		$form_submit.prop('disabled', true);

		// Check that Stripe is indeed the gateway chosen.
		var chosen_gateway = $form.find('input[name="give-gateway"]').val();
		if (chosen_gateway !== 'stripe_ach') {
			return;
		}

		e.preventDefault();

		var linkHandler = Plaid.create({
			env: give_stripe_ach_vars.plaid_endpoint,
			apiVersion: give_stripe_ach_vars.plaid_api_version,
			clientName: give_stripe_ach_vars.sitename,
			key: give_stripe_ach_vars.plaid_public_key,
			product: 'auth',
			selectAccount: true,
			onSuccess: function onSuccess(public_token, metadata) {

				// insert the token into the form so it gets submitted to the server
				$form.append("<input type='hidden' name='give_stripe_ach_token' value='" + public_token + "' />");
				$form.append("<input type='hidden' name='give_stripe_ach_account_id' value='" + metadata.account_id + "' />");
				// submit
				$form.get(0).submit();
			},
			onExit: function onExit() {

				// Remove loading animations
				$form.find('.give-loading-animation').hide();
				// Re-enable submit button.
				$form_submit.prop('disabled', false);
				// button and add back text.
				$form_submit.val(donate_button_val);
			}
		});

		linkHandler.open();
	});
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/give-stripe-ach.js